import React from 'react';
import { EditorWizardProvider } from '../../hoc/EditorWizard';
import WizardPage from '../../components/Wizard/MainPage';

const CreateCourseSchool = () => (
  <>
    <EditorWizardProvider>
      <WizardPage />
    </EditorWizardProvider>
  </>
);

export default CreateCourseSchool;
